module.exports = __webpack_public_path__ + "static/hobgoblin_devastator-efb08d5a38445328ebba4df94a3d0f49.jpeg";